import { render, staticRenderFns } from "./OrderPaymentTermChart.vue?vue&type=template&id=6e7bf7af&"
import script from "./OrderPaymentTermChart.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentTermChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports